import * as React from 'react';
import {Component} from 'react';
import {Toast, toastMessage, PriorityIcon, Icon} from '@priority-software/priority-style-react';
import {isRTL} from '../../../Localization';
import {registerToastCallbacks} from '../actions/ToastActions';
import styles from '../styles/Toast.module.scss';

type toastType = 'success' | 'error';

type Props = {
    containerId?: string;
    componentClasses?: string;
};

class ToastModal extends Component<Props> {
    componentDidMount() {
        registerToastCallbacks(this.showToast);
    }

    showToast = (message, type: toastType = 'success', toastProps = {}) => {
        const icon =
            type === 'success' ? (
                <Icon componentClasses={styles.sucssesColor} icon={PriorityIcon.roundCheck} />
            ) : (
                <Icon componentClasses={styles.errorColor} icon={PriorityIcon.warning} />
            );
        const content = (
            <div className={styles.contentBody}>
                {icon}
                <div className={styles.message}>{message}</div>
            </div>
        );

        //This function comes from the React-Tostify component and accept a string param, once execute its shows the toast messsage.
        toastMessage(content, toastProps);
    };

    render() {
        return <Toast rtl={isRTL()} {...this.props} />;
    }
}

export default ToastModal;
